export const priceDiff = (item) => {
    if (!item.variants?.[0]?.originalPrice || !item.variants?.[0]?.price) return 0;

    return (
        Math.round(
            Math.max(((item.variants[0].originalPrice - item.variants[0].price) / item.variants[0].originalPrice) * 100)
        ) || 0
    );
};
